<template>
  <van-popup v-model="show" :overlay=false :style="{ width: '100%', height: '100vh' }">
    <div class="recharge-container">
      <!-- 标题栏 -->
      <div class="pc-title pc-title1">
        <p class="icon">
          <i @click="closePopup" class="el-icon-close"></i>
        </p>
        <span>充值</span>
      </div>

      <div class="rp-con">
        <div class="cz-img">
          <img class="close-icon" src="~@/assets/imgs/cz.png" alt="">
          <span></span>
        </div>

      </div>

      <div>
        <!-- 充值金额选择 -->
        <div class="amount-selection">
          <div class="preset-amounts">
            <div
                v-for="option in amountOptions"
                :key="option.value"
                class="amount-option font2"
                :class="{ active: selectedAmount === option.value }"
                @click="selectAmount(option.value)">
              {{ option.label }}
            </div>
          </div>

          <div class="custom-amount">
            <p class="section-label">自定义金额</p>
            <input
                type="number"
                v-model="customAmount"
                class="amount-input"
                placeholder="输入金额"
                @input="onCustomAmountInput"
            >
          </div>

          <p class="gas-fee">
            余额: {{$formatDecimals(USDTBalance)}} USDT
            <em @click="clickMax">MAX</em>
          </p>
        </div>
        <!-- 底部按钮 -->
        <div class="action-footer">
          <button class="ty-button ty-button1" @click="closePopup">取消</button>
          <button class="ty-button" @click="confirmRechargePar">确认</button>
<!--          <button class="ty-button" @click="confirmRechargePar">授权</button>-->
        </div>
      </div>

    </div>
  </van-popup>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'RechargePopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      amount: '10000.23',
      points: '10',
      selectedAmount: 50,
      customAmount: '50',
      amountOptions: [
        { label: '10 U', value: 10 },
        { label: '50 U', value: 50 },
        { label: '100 U', value: 100 },
        { label: '500 U', value: 500 }
      ]
    };
  },
  computed: {
    ...mapState([
      "accountInfo",
      "USDTBalance",
    ]),
  },
  methods: {
    async sq(){

    },
    // 点击max
    clickMax() {
      this.customAmount = this.USDTBalance
    },
    closePopup() {
      if(Number(this.USDTBalance) > 50){
        this.customAmount = 50
      }else{
        this.customAmount = this.USDTBalance
        this.selectedAmount = null
      }
      this.$parent.$parent.getTrade()
      this.$emit('update:show', false);
    },
    selectAmount(value) {
      this.selectedAmount = value;
      this.customAmount = value.toString();
    },
    onCustomAmountInput() {
      const numValue = Number(this.customAmount);
      const matchedOption = this.amountOptions.find(option => option.value === numValue);

      if (matchedOption) {
        this.selectedAmount = matchedOption.value;
      } else {
        this.selectedAmount = null;
      }
    },
    // 点击充值
    async confirmRechargePar(){
      const vm = this;
      if (parseFloat(vm.USDTBalance) < parseFloat(vm.customAmount)) {
        vm.$toast({
          message: '余额不足',
          position: 'top',
        });
        return
      }
      // 1. 检查授权
      const address = "0x55d398326f99059fF775485246999027B3197955"
      const allowanceResult = await threeKingdoms.checkTokenAllowance(
          address,
          vm.accountInfo);
      const tradeAmount = await threeKingdoms.toReal(vm.customAmount,18)
      // 2. 如果需要授权
      if (Number(tradeAmount) > Number(allowanceResult)) {
        vm.$toast('授权额度不足，正在进行授权...');
        await threeKingdoms.approveToken(address);
        vm.$toast('授权已发送，继续充值...');
      }

      const createInfo = await vm.confirmRecharge();
      if (!createInfo) throw new Error('获取交易数据失败');

      const txHash = await threeKingdoms.sendTransaction(createInfo);
      if (!txHash) throw new Error('发送交易失败');

      // 4. 等待交易确认
      const receipt = await threeKingdoms.waitForTransactionReceipt(txHash);
      if (!receipt.success) throw new Error('交易失败');

      vm.$toast({
        message: '充值成功~',
        position: 'top',
      });

      vm.closePopup()

    },
    async confirmRecharge() {
      const vm = this
      const amount = vm.customAmount || vm.selectedAmount;
      if (!amount) {
        this.$toast('请选择或输入充值金额');
        return;
      }else{
        let params = {
          "userAddress": vm.accountInfo,
          "depositAmount": vm.customAmount,
        }
        try {
          const response = await vm.$axios.post('/alpha/txs/create/deposit', params);
          const {success, msg, data} = response.data;
          if (!success) {
            vm.$message.error(msg || '请求数据失败');
            return null;
          }else{
            return data;
          }
        } catch (error) {
          vm.isStart = 2
          console.error('请求买入交易数据失败:', error);
          vm.$toast({
            message: error || '错误~',
            position: 'top',
          });
          return null;
        }
      }
    }
  },
  mounted() {
    this.customAmount = this.selectedAmount.toString();
  }
};
</script>

<style lang="scss" scoped>
.recharge-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .rp-con{
    flex: 1;
    overflow: hidden;
  }
  .cz-img{
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      display: block;
      width: 100%;
    }
  }
}

.amount-selection {
  padding: 20px;
  
  .preset-amounts {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 20px;
    
    .amount-option {
      height: 80px;
      border: 0.5px solid $border;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      color: #000;
      position: relative;
      &:nth-child(2){
        &:before{
          position: absolute;
          top:0;
          left:0;
          content: '推荐';
          font-size: 10px;background-color: #000;
          border-radius: 10px 0 8px 0;
          padding:0 5px;
          color: #fff;
        }
      }
      &.active {
        border-color: #000;
      }
    }
  }
  
  .custom-amount {
    .section-label {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
      color: #000;
    }
    
    .amount-input {
      width: 100%;
      height: 52px;
      line-height: 52px;
      border: 0.5px solid $border;
      border-radius: 8px;
      padding: 0 10px;
      font-size: 18px;
      color: #000;
      outline: none;
    }
  }
}

.action-footer {
  margin-top: auto;
  padding: 20px;
  display: flex;
  gap: 10px;
  button{
    height: 44px;
    line-height: 44px;
  }
}
.gas-fee {
  margin-top: 8px;
  font-size: 14px;
  color: $color1;
  em{
    padding-left: 5px;
    color: rgb(0, 157, 255);
  }
}
</style>